import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
    root: {
        height: theme.custom.variables.headerHeight,
        backgroundColor: theme.palette.background.darkTransparent,
        // backgroundImage: `linear-gradient(to top, ${theme.palette.background.main} 10%, ${theme.palette.background.darkTransparent}, ${theme.palette.background.darkTransparent}, ${theme.palette.background.darkTransparent})`
    },
    logo: {
        width: 150
    },
    title: {
        lineHeight: 1,
        color: "white"
    },
    toolbar: {
        paddingRight: 24,
        justifyContent: "space-between",
    },
    appBar: {
        borderTopLeftRadius: 5,
        marginLeft: theme.custom.variables.closedMenuLeftWidth,
        width: `calc(100% - ${theme.custom.variables.closedMenuLeftWidth}px)`,
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        })
    },
    appBarShift: {
        marginLeft: theme.custom.variables.menuLeftWidth,
        width: `calc(100% - ${theme.custom.variables.menuLeftWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    appBarFolded: {
        top: "0%"
    },
    menuButton: {
        marginRight: 10,
    },
    searchInput: {
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none"
        },
        backgroundColor: theme.palette.background.default,
        boxShadow: "rgba(0, 0, 0, 0.15) 0.5px 1px 2px 0px inset",
        transition: theme.transitions.create('width'),
        width: '29ch',
        '&:hover': {
            width: '31ch',
        },
    },
    rootSticky: {
        height: theme.custom.variables.headerHeight - 5,
    },
    gridContainer: {
        padding: theme.spacing(0, 4),
        height: "100%",
    },
    popupItems: {
        margin: "5px 10px",
        width: "120px",
        textAlign: "center",
    },
    listItemText: {
        margin: "5px 10px",
        minWidth: "150px",
        textAlign: "left",
    },
    languageItemText: {
        margin: "5px 10px",
        width: "100px",
        textAlign: "left",
    }
}));
